import ActiveAgenda from '../components/active-agenda/active-agenda'
import NextPatient from '../components/next-patient/next-patient'
import SelectDates from '../components/select-dates/dates'
import StatisticsAgendas from '../components/statistics/statistics'

export default {
  SelectDates,
  StatisticsAgendas,
  NextPatient,
  ActiveAgenda

}



// WEBPACK FOOTER //
// ./src/app/employee/dashboard/gadget/resources/components.js